import React from 'react';
import ContactForm from './ContactForm';

const SignUpForm = ({ closeModal }) => {
  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <button className="close-btn" onClick={closeModal}>×</button>
        <div className="bg-white p-9 modal-container flex flex-col items-center justify-center">
          <ContactForm />
        </div>
      </div>
    </div>
  );
};

export default SignUpForm;